module.exports = __webpack_public_path__ + "static/media/terminology-purchase.61dd383f.svg";